import useSWR from "swr";
import useSWRMutation from "swr/mutation";
import { mapRawToMask, mapRawToMaskWithStructures } from "@/mappers/mask";
import { CreateMask, RawMask, RawMaskWithStructures, UpdateMask } from "@/types/mask";
import {
  SWRApiError,
  swrConfigOptions,
  UpdaterParams,
  useDeleteUrl,
  useFetcher,
  useMutater,
  useUpdater,
} from "./swr";

export const useMasks = () => {
  const fetcher = useFetcher();

  const { data = [], ...rest } = useSWR<RawMask[], SWRApiError>(
    { url: "/masks" },
    fetcher,
    swrConfigOptions,
  );

  return { data: data.map(mapRawToMask), ...rest };
};

export const useProjectMasks = (projectId: string | number | undefined) => {
  const fetcher = useFetcher();

  const { data = [], ...rest } = useSWR<RawMask[], SWRApiError>(
    projectId ? { url: `/projects/${projectId}/masks` } : null,
    fetcher,
    swrConfigOptions,
  );

  return { data: data.map(mapRawToMask), ...rest };
};

export const useMaskStructures = (maskId?: string) => {
  const fetcher = useFetcher();

  const { data, ...rest } = useSWR<RawMaskWithStructures, SWRApiError>(
    maskId ? { url: `/masks/${maskId}/structures` } : null,
    fetcher,
    swrConfigOptions,
  );

  return {
    data: data ? mapRawToMaskWithStructures(data) : null,
    ...rest,
  };
};

export const useDeleteMaskXMLDesigns = (maskId?: string) => {
  const deleter = useDeleteUrl();

  return useSWRMutation<void, SWRApiError, string>(
    maskId ? `/masks/${maskId}/xml_designs` : "",
    deleter,
  );
};

export const useDeleteMaskCSVDesigns = (maskId?: string) => {
  const deleter = useDeleteUrl();

  return useSWRMutation<void, SWRApiError, string>(
    maskId ? `/masks/${maskId}/csv_designs` : "",
    deleter,
  );
};

export const useCreateMask = () => {
  const mutater = useMutater();

  return useSWRMutation<any, SWRApiError, string, CreateMask>("/masks", mutater);
};

export const usePatchMask = () => {
  const updater = useUpdater();

  return useSWRMutation<void, SWRApiError, UpdaterParams, UpdateMask & { id: string }>(
    { url: `/masks` },
    updater,
  );
};
